// REACT
import { useReducer } from "react";

// MATERIAL UI
import { Box, Typography } from "@mui/material";

// COMPONENTS
import NoFooterLayout from "../components/core/NoFooterLayout";
import Profile from "src/components/settings/profile/Profile";
import UsefulLinks from "src/components/settings/usefulLinks/UsefulLinks";
import PagesWithHeaders from "src/components/common/PageWithHeaders";
import Security from "src/components/settings/security/Security";
import { Payment } from "src/components/settings/payment/Payment";

// HOOKS
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import { usePermissionGuard } from "src/PermissionGuard";
import ReferralCodeEntry from "src/components/settings/Referrals/ReferralCodeEntry";

export interface ISettingsTabProps {
  path: string;
  component: JSX.Element;
  title: string;
}

const Settings = () => {
  const [useDefaultTheme, toggle] = useReducer((theme: any) => !theme, true);
  const isMobile = useIsMobile();

  // This is a temporary measure to ensure only users with the correct permissions can access the
  // payment settings page. Will be removed once we go live with the feature
  const { hasPermission } = usePermissionGuard();
  const isGuest = hasPermission(["guest"]);

  const baseTabs: ISettingsTabProps[] = [
    {
      path: "/settings/profile",
      component: <Profile />,
      title: "Profile",
    },
    {
      path: "/settings/security",
      component: <Security />,
      title: "Security",
    },
    {
      path: "/settings/usefulLinks",
      component: <UsefulLinks />,
      title: "Help",
    },
  ];

  const referralTab: ISettingsTabProps = {
    path: "/settings/referral",
    component: <ReferralCodeEntry />,
    title: "Referral",
  };

  const userTabs = [...baseTabs, ...(!isGuest ? [referralTab] : [])];

  return (
    <NoFooterLayout toggleTheme={toggle} useDefaultTheme={useDefaultTheme}>
      <Box sx={isMobile ? { padding: "0" } : { padding: "0 2rem" }}>
        <div style={{ paddingLeft: isMobile ? "16px" : "0" }}>
          <Typography
            sx={{
              fontFamily: "Roobert, sans-serif",
              fontSize: "28px",
              fontWeight: 600,
              lineHeight: "34px",
              letterSpacing: "-0.56px",
              color: "#002035",
              paddingTop: "10px",
            }}>
            Settings
          </Typography>
        </div>
        <PagesWithHeaders components={userTabs} default={<Profile />} />
      </Box>
    </NoFooterLayout>
  );
};

export default Settings;
